import styled from "styled-components"

const H4 = styled.div<{ textAlign?: string; color?: string }>`
  color: ${(props) => props.color ?? props.theme.colors.greyDark};

  font-family: "Karla", "Karla-fallback", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;

  text-align: ${(props) => props.textAlign ?? "left"};
`

export default H4
